import {ChevronRightIcon} from '@primer/octicons-react'

type LinkLabelProps = {
  children: React.ReactNode | string
}

const LinkLabel = ({children, ...restProps}: React.HTMLAttributes<HTMLElement> & LinkLabelProps) => {
  return (
    <span className="d-flex fgColor-muted flex-items-center gap-2 height-full" {...restProps}>
      {children}
      <ChevronRightIcon />
    </span>
  )
}
LinkLabel.displayName = 'ControlGroup.LinkLabel'

export default LinkLabel
